export const PaymentGatewayStatusCssClasses = ["danger", "success", "info", ""];
export const PaymentGatewayStatusTitles = [
  "Suspended",
  "Active",
  "Pending",
  "",
];
export const PaymentGatewayTypeCssClasses = ["success", "primary", ""];
export const PaymentGatewayTypeTitles = ["Business", "Individual", ""];
export const defaultSorted = [{ dataField: "created_at", order: "desc" }];
export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "50", value: 50 },
  { text: "100", value: 100 },
];
export const initialFilter = {
  code: "",
  name: "",
  email: "",
  hp: "",
  sort_order: "DESC", // asc||desc
  sort_field: "created_at",
  page_number: 1,
  page_size: 10,
};

export let initialValue = {
  code: "",
  config: "",
};

export const status = [
  {
    name: "Aktif",
    value: "ACTIVE",
  },
  {
    name: "Tidak Aktif",
    value: "INACTIVE",
  },
];

export const category = [
  {
    name: "Global",
    value: "GLOBAL",
  },
  {
    name: "Individu",
    value: "INDIVIDU",
  },
];

export const badge = (status) => {
  let data = {};
  if (status === "ACTIVE") data = { text: "ACTIVE", type: "success" };
  else data = { text: "INACTIVE", type: "warning" };

  return data;
};
